export default "__VITE_ASSET__f5ee2741__"